import React from 'react'
import { useOrderStore } from 'src/hooks/order';
import { Pagination } from 'src/reusable/global';
import System from "../../../../helper/system";
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { expandRow } from 'src/store/slice/model/Order/OrderHistoryUI';
import OrderHistoryDateFilter from '../Filters/OrderHistoryDateFilter';
import OrderHistorySearchFilter from '../Filters/OrderHistorySearchFilter';
import useReduxState from 'src/hooks/useReduxState';
import Helper from 'src/support/Helper';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Product from "@system/config/product";
import { useThrottle } from "webrix/hooks";
import stickyTableHeader from 'src/helper/stickyTableHeader';
import $ from 'jquery';
import Constants from 'src/support/Constants';
import { useAdminAccountFilterStore } from 'src/hooks/admin/adminAccountFilter';
import returnrequest from "src/assets/images/returnrequest-icon.svg";
import returnrequestinactive from "src/assets/images/returnrequest-icon-inactive.svg";
import { Tooltip } from 'src/component/Tooltip';
import NavigateToPDP from 'src/component/Global/Product/NavigateToPDP';

const OrderHistoryListing = (props) => {
    const [__check] = useAxiosIndicatorCheck();

    const [{ order_list }, { fetch_order_list, fetch_order_export_count }, { export_order, order_download_single_invoice }] = useOrderStore();
    const [{ filter_list }, { }, { set_filter_list }] = useAdminAccountFilterStore();
    const dispatch = useDispatch();
    const expand_list = useSelector((state) => state.entities.model_OrderHistory__UI.expandArray)
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);
    const [expandedRow, setExpandedRowT] = useState('')
    const setExpandedRow = useThrottle(setExpandedRowT, 1)
    const [filterOrderStatus] = useReduxState('', 'setFilterOrderStatus');
    const [dateRange] = useReduxState('', 'setDateRange');
    const [isExportFilter, setIsExportFilter] = useReduxState(false, 'setIsExportFilter');
    const [manufacturerDropdownList, setManufacturerDropdownList] = useReduxState([], 'setManufacturerDropdownList');
    const accountNo = System.getParams().accountNumber;
    const salesOrg = System.getParams().salesOrg;
    const orderDate = System.getParams().orderDate;
    const searchTypeAPIList = [
        'OrderNumber', 'PoNumber', 'InvoiceNumber', 'Tracking'
    ]
    const [listObj, setListObj] = useState({
        pageCount: 0,
        page: 1,
        limit: 20,
        sortBy: '',
        sortOrder: '',
        ascDesField: {}
    });

    useEffect(() => {
        if (order_list.orderList && Object.entries(order_list.orderList).length > 0 && order_list.total !== undefined) {
            setTimeout(() => {
                $(".floating-table").floatingScroll("init");
            }, 2500)
        }
    }, [order_list])


    useEffect(() => {
        const getList = async () => {
            if (order_list.total && order_list.total > 0) {
                const total = order_list.total;
                await setListObj({ ...listObj, pageCount: Math.ceil(total / listObj.limit) })
            }

            if (order_list.orderList !== undefined && Object.entries(order_list.orderList).length > 0) {
                let manufacturerList = []
                Object.entries(order_list.orderList).map((value) => {
                    if (value[1] && value[1].manufacturerName) {
                        manufacturerList.push(value[1].manufacturerName)
                    }
                });

                setManufacturerDropdownList([... new Set(manufacturerList)])

                await dispatch(expandRow('reset'))
                if ((filter_list && filter_list.length > 0) || (filterOrderStatus.trim().length > 0)) {
                    Object.entries(order_list.orderList).map(async (value) => {
                        await dispatch(expandRow(value[1].orderNumber))
                    });
                }
            }
        };
        getList();
    }, [order_list]);


    const defaultPageActive = async () => {
        setListObj({ ...listObj, page: 1 })
    }

    const handlePageClick = async (data) => {
        let here_page = 0
        here_page = data.selected + 1;
        setListObj({ ...listObj, page: here_page })
        Helper.scrollTop();
    };

    const setPageLimit = async (event) => {
        await setListObj({ ...listObj, limit: event.target.value })
    };

    useEffect(() => {
        const getList = async () => {
            await fetchAPICall();
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.page, listObj.sortBy,listObj.sortOrder, isExportFilter]);

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPICall()
            } else {
                await defaultPageActive()
            }
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.limit, filterOrderStatus]);

    useEffect(() => {
        async function f() {
            if (expandedRow && expandedRow.orderNumber !== undefined)
                return dispatch(expandRow(expandedRow.orderNumber));
        }

        f()
    }, [expandedRow]);

    useEffect(() => {
        if (window.location.href.includes('orderNumber') && window.location.href.includes('POLineItemNumber')) {
            const searchParams = new URLSearchParams(window.location.search);
            let orderSearch = [{
                searchType: "OrderNumber",
                searchKeyword: searchParams.get('orderNumber')?.trim()
            },
                {
                    searchType: "POLineItemNumber",
                    searchKeyword: searchParams.get('POLineItemNumber')?.trim()
                }
            ]
            // Remove accountNumber & salesOrg if exist in url - 07-05-2024 - PN
            if (searchParams.get("accountNumber") && searchParams.get("salesOrg")) {
                removeURLParameter("accountNumber");
                removeURLParameter("salesOrg");
            }
            const filterListObject = orderSearch?.reduce((acc, curr) => {
                let key = curr?.searchType
                acc[key] = {
                    searchType: curr?.searchType,
                    searchKeyword: curr?.searchKeyword
                };
                return acc;
            }, {});
            set_filter_list(filterListObject)

            function removeURLParameter(param) {
                const url = new URL(window.location.href);
                const searchParams = url.searchParams;

                if (searchParams.has(param)) {
                    searchParams.delete(param);
                }

                const newUrl = url.href;
                history.replaceState(null, '', newUrl);
            }
            removeURLParameter('orderNumber');
            removeURLParameter('POLineItemNumber');
            removeURLParameter('orderDate');
        }
    }, [])

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPICall()
            } else {
                await defaultPageActive()
            }
        };
        getList()
    }, [dateRange, filter_list])

    const fetchAPICall = async (
        defaultStart = false
    ) => {
        let search_type = ''
        let search_keyword = ''
        let filter_option = []

        if (Object.entries(filter_list).length > 0) {
            Object.entries(filter_list).map(obj => {
                let tempObj
                if (obj[0] == 'Manufacturer') {
                    tempObj = {
                        key: obj[0],
                        value: (obj[1]?.searchKeywordArr?.map((e) => e.value)).join("|")
                    }
                } else {
                    tempObj = {
                        key: Constants.orderPayload[obj[0]],
                        value: obj[1].searchKeyword
                    }
                }
                filter_option.push(tempObj)
            })

        }
        if (filterOrderStatus) {
            let tempObj = {
                key: 'OrderStatus',
                value: filterOrderStatus
            }
            filter_option.push(tempObj)
        }

        if (dateRange && !dateRange.includes("Invalid date")) {
            let tempObj = {
                key: 'OrderDate',
                value: dateRange
            }
            filter_option.push(tempObj)
        }

        let params = {
            "keyword": search_keyword,
            "searchType": search_type,
            "timeSpan": "",
            "start": defaultStart ? 0 : (listObj.limit * (listObj.page - 1)),
            "pageSize": Number(listObj.limit), //&& (((Number(limit) * (page - 1) + (Number(limit)))))
            "sortBy": listObj.sortBy ? listObj.sortBy : 'orderDate',
            "sortOrder": listObj.sortOrder ? listObj.sortOrder : 'desc',
            "filterByOption": filter_option,
        }

        if (isExportFilter === true) {
            setTimeout(() => {
                System.popup('ThankYouPopup', { isOrderHistory: true }); // open pop-up before API Call
            }, 2000);
            await export_order({
                ...params,
                "isExportAll": false,
                "isEmail": true
            })

            await setIsExportFilter(false)
        } else {
            if (dateRange) {
                let result = await fetch_order_list(params)
                if (result?.payload?.total === 0) {
                    await fetch_order_export_count()
                }
                await setFirstServerCall(false);
            }
        }
    };

    const toggleOrderBy = async (columnName) => {
        if (listObj.ascDesField.hasOwnProperty(columnName)) {
            listObj.ascDesField[columnName] = listObj.ascDesField[columnName] === 'ASC' ? 'DESC' : 'ASC'
            setListObj({ ...listObj, ascDesField: listObj.ascDesField})

        } else {
            listObj.ascDesField[columnName] = 'ASC'
            setListObj({ ...listObj, ascDesField: listObj.ascDesField})

        }
        setListObj({ ...listObj, sortBy: columnName,sortOrder:listObj.ascDesField[columnName] })
    };

    const getOrderByClass = (columnName) => {
        if (listObj.sortBy === columnName && listObj.ascDesField.hasOwnProperty(columnName)) {
            return 'sorting sorting_' + listObj.ascDesField[columnName].toLowerCase()
        }
        return 'sorting'
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        if (firstServerCall === false && !monitorFunctionCall && !(__check('ORDER_API_CALL').status)) {
            Helper.monitorJSDx()
            setMonitorFunctionCall(true)
        }
    }, [__check('ORDER_API_CALL').status])

    const downloadSingleInvoice = async (invoiceNumber) => {
        let result = await order_download_single_invoice({ invoiceNumber: invoiceNumber });
        if (result?.payload) {
            showDownloadMessage();
        }
    }

    /**
     * Bug    #  : 9670
     * Change #  : Display download message on download
     * Change by : PN
     * Date      : 4 Aug 2023
     */
    const showDownloadMessage = () => {
        System.alert(Constants.downloadMsg, 'success')
    }

    useEffect(() => {
            /**
             * Author: Trilok
             * Date: 07/04/23
             * Reason: dislay sticky table header
             */
            let isDisplayFixedHeader = false;
            let refreshStockButton;
            let callback;
            const list = order_list?.orderList
            if (list && Object.keys(list).length > 0) {
                const sort = toggleOrderBy;
                // table elelment with unique id
                const tableElement = document?.getElementById("orderhistory-table");
                // headerHeght contains height where we need to display static header
                //local
                // const headerHeight =  document?.getElementsByTagName("header") ? document?.getElementsByTagName("header")[0]?.clientHeight :65;
                //sbx
                let headerHeight = document?.getElementsByClassName("navbar navbar-default white") ? document?.getElementsByClassName("navbar-default")[0]?.clientHeight + 1 : 65 + 1;
                // is used to track only one header will display at a moment

                // Admin Toolbar header height adjustment
                const adminToolBarHeight = document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")?.length > 0 ? document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")[0]?.clientHeight : 0;

                if (adminToolBarHeight > 0) {
                    headerHeight = headerHeight + adminToolBarHeight;
                }

                document.addEventListener("scroll", (ScrollEvent) => {
                    // current table position from top
                    const tablePosition = tableElement ? tableElement?.getBoundingClientRect().y : false;
                    const paginationPosition = document?.querySelectorAll("div.pagination-row") ? document?.querySelectorAll("div.pagination-row")[0]?.getBoundingClientRect().y : false;
                    if (tablePosition && headerHeight > tablePosition && isNaN(paginationPosition) === false && (Number(headerHeight) + 40 <= Number(paginationPosition)) && !isDisplayFixedHeader) {
                        //function used to display header clone after actual header height is less than headerHeight from top
                        // function(id, headerHeight,  tableContainerId, noOfColummFixed, sort)
                        callback = stickyTableHeader("orderhistory-table", headerHeight, "sticky-table-wrapper", 3, sort)
                        //fixed header display now on ui
                        isDisplayFixedHeader = true
                    } else {
                        if ((headerHeight < tablePosition || (Number(paginationPosition) <= Number(headerHeight) + 40)) && isDisplayFixedHeader && callback) {
                            // switch variable to false for track that clone header hide
                            isDisplayFixedHeader = false;
                            // function used to remove the clone header
                            if (Object.prototype.toString.call(callback) == '[object Function]') {
                                callback();
                            }
                        }
                    }
                })
            }
            return () => {
                if (callback) {
                    // switch variable to false for track that clone header hide
                    isDisplayFixedHeader = false;
                    // check element exist before remove event listeners
                    if (refreshStockButton && refreshStockButton[1]) {
                        refreshStockButton[1]?.removeEventListener("click", refreshStock);
                    }
                    // function used to remove the clone header
                    callback();
                }
            }

        }
        , [order_list.orderList, __check(['ORDER_API_CALL']).status]);



    return (
        <>
            {!firstServerCall && <OrderHistorySearchFilter />}
            <OrderHistoryDateFilter orderDate={orderDate} firstServerCall={firstServerCall} />
            {(__check('ORDER_API_CALL').status || (order_list.orderList !== undefined &&
                    Object.entries(order_list.orderList).length > 0)) &&
                <div className='position-relative'>
                    <div>
                        {__check(['ORDER_API_CALL'], { overlay: true }).render}
                    </div>
                    {
                        <div id="sticky-table-wrapper" className="table-responsive m-t-15 floating-table sticky-table-wrapper">
                            <table id="orderhistory-table" className="bs5 table sticky-table table-bordered orderhistory-table sticky-table-six">
                                <thead>
                                <tr>
                                    <th></th>
                                    <th>RMA</th>
                                    <th className='minw190'><span>P.O. Number</span>
                                        <span aria-label="PONumber" aria-pressed="false" className={'sort-container ' +
                                            (getOrderByClass('PONumber'))
                                        }
                                              onClick={async () => {
                                                  await toggleOrderBy('PONumber')
                                              }}></span>
                                    </th>
                                    <th className='minw130'><span>P.O. Line Item Number</span>
                                        <span aria-label="poline" aria-pressed="false" className={'sort-container ' +
                                            (getOrderByClass('poline'))
                                        }
                                              onClick={async () => {
                                                  await toggleOrderBy('poline')
                                              }}></span>
                                    </th>
                                    <th className='minw140'><span>Order Number</span>
                                        <span aria-label="OrderNumber" aria-pressed="false" className={'sort-container ' +
                                            (getOrderByClass('OrderNumber'))
                                        }
                                              onClick={async () => {
                                                  await toggleOrderBy('OrderNumber')
                                              }}></span>
                                    </th>

                                    <th className='minw100'>
                                        Line Item Number
                                    </th>

                                    <th className='minw130'>
                                        <span>Manufacturer</span>
                                        <span aria-label="ManufacturerName" aria-pressed="false"
                                              className={'sort-container ' + getOrderByClass('ManufacturerName')}
                                              onClick={async () => {
                                                  await toggleOrderBy('ManufacturerName')
                                              }}></span>
                                    </th>

                                    <th className="minw150">
                                        <span>Manufacturer Part Number</span>
                                        <span aria-label="ManufacturerPartNumber" aria-pressed="false" className={'sort-container ' +
                                            (getOrderByClass('ManufacturerPartNumber'))}
                                              onClick={async () => {
                                                  await toggleOrderBy('ManufacturerPartNumber')
                                              }}></span>
                                    </th>

                                    <th className="minw130">
                                        <span>Customer Part Number</span>
                                        <span aria-label="CustomerPartNumber" aria-pressed="false" className={'sort-container ' +
                                            (getOrderByClass('CustomerPartNumber'))}
                                              onClick={async () => {
                                                  await toggleOrderBy('CustomerPartNumber')
                                              }}></span>
                                    </th>

                                    <th>
                                        Ordered Quantity

                                        <span aria-label="TotalQuantity" aria-pressed="false" className={'sort-container ' +
                                            getOrderByClass('TotalQuantity')}
                                              onClick={async () => {
                                                  await toggleOrderBy('TotalQuantity')
                                              }}></span>
                                    </th>

                                    <th>
                                        Requested Quantity
                                        <span aria-label="RequestedQuantity" aria-pressed="false" className={'sort-container ' +
                                            getOrderByClass('RequestedQuantity')}
                                              onClick={async () => {
                                                  await toggleOrderBy('RequestedQuantity')
                                              }}></span>
                                    </th>

                                    <th>
                                        Requested Date
                                        <span aria-label="RequestedDate" aria-pressed="false" className={'sort-container ' +
                                            getOrderByClass('RequestedDate')}
                                              onClick={async () => {
                                                  await toggleOrderBy('RequestedDate')
                                              }}></span>
                                    </th>
                                    <th>
                                        Confirmed Quantity
                                        <span aria-label="ConfirmedQuantity" aria-pressed="false" className={'sort-container ' +
                                            getOrderByClass('ConfirmedQuantity')}
                                              onClick={async () => {
                                                  await toggleOrderBy('ConfirmedQuantity')
                                              }}></span>
                                    </th>

                                    <th>
                                        Estimated Delivery Date
                                        <span aria-label="ConfirmedDate" aria-pressed="false" className={'sort-container ' +
                                            getOrderByClass('ConfirmedDate')}
                                              onClick={async () => {
                                                  await toggleOrderBy('ConfirmedDate')
                                              }}></span>
                                    </th>

                                    <th className='minw100'>
                                        Order Item Status
                                        <span aria-label="OrderStatus" aria-pressed="false" className={'sort-container ' +
                                            (getOrderByClass('OrderStatus'))}
                                              onClick={async () => {
                                                  await toggleOrderBy('OrderStatus')
                                              }}></span>
                                    </th>
                                    <th>
                                        Shipped Quantity
                                        <span aria-label="ShippedQuantity" aria-pressed="false" className={'sort-container ' +
                                            getOrderByClass('ShippedQuantity')}
                                              onClick={async () => {
                                                  await toggleOrderBy('ShippedQuantity')
                                              }}></span>
                                    </th>
                                    <th>
                                        Delivery Number
                                        <span aria-label="DeliveryNumber" aria-pressed="false" className={'sort-container ' +
                                            getOrderByClass('DeliveryNumber')}
                                              onClick={async () => {
                                                  await toggleOrderBy('DeliveryNumber')
                                              }}></span>
                                    </th>
                                    <th>
                                        Tracking Number
                                        <span aria-label="TrackingNumber" aria-pressed="false" className={'sort-container ' +
                                            getOrderByClass('TrackingNumber')}
                                              onClick={async () => {
                                                  await toggleOrderBy('TrackingNumber')
                                              }}></span>
                                    </th>
                                    <th><span>CURRENCY</span></th>
                                    <th>
                                        Price
                                        <span aria-label="Price" aria-pressed="false" className={'sort-container ' +
                                            getOrderByClass('Price')}
                                              onClick={async () => {
                                                  await toggleOrderBy('Price')
                                              }}></span>
                                    </th>
                                    <th className='minw100'>
                                        Price Base Quantity
                                        <span aria-label="PriceBasedQuantity" aria-pressed="false" className={'sort-container ' +
                                            (getOrderByClass('PriceBasedQuantity'))}
                                              onClick={async () => {
                                                  await toggleOrderBy('PriceBasedQuantity')
                                              }}></span>
                                    </th>
                                    <th>
                                        Currency Fluctuation
                                        <span aria-label="CurrencyFluctuation" aria-pressed="false" className={'sort-container ' +
                                            getOrderByClass('CurrencyFluctuation')}
                                              onClick={async () => {
                                                  await toggleOrderBy('CurrencyFluctuation')
                                              }}></span>
                                    </th>
                                    <th><span>CF Currency</span></th>
                                    <th className='minw100'>
                                        CF Agreed Rate
                                        <span aria-label="CfAgreedRate" aria-pressed="false" className={'sort-container ' +
                                            (getOrderByClass('CfAgreedRate'))}
                                              onClick={async () => {
                                                  await toggleOrderBy('CfAgreedRate')
                                              }}></span>
                                    </th>
                                    <th className='minw120'>
                                        Item Total Price
                                        <span aria-label="ItemTotalPrice" aria-pressed="false" className={'sort-container ' +
                                            (getOrderByClass('ItemTotalPrice'))}
                                              onClick={async () => {
                                                  await toggleOrderBy('ItemTotalPrice')
                                              }}></span>
                                    </th>
                                    <th className='minw140'>
                                        Invoice Number
                                        <span aria-label="InvoiceNumber" aria-pressed="false" className={'sort-container ' +
                                            (getOrderByClass('InvoiceNumber'))}
                                              onClick={async () => {
                                                  await toggleOrderBy('InvoiceNumber')
                                              }}></span>
                                    </th>
                                    <th className='minw120'>
                                        Web Order Number
                                        <span aria-label="WebOrderNumber" aria-pressed="false" className={'sort-container ' +
                                            (getOrderByClass('WebOrderNumber'))}
                                              onClick={async () => {
                                                  await toggleOrderBy('WebOrderNumber')
                                              }}></span>
                                    </th>
                                    <th>Buyer
                                        <span aria-label="BuyerName" aria-pressed="false" className={'sort-container ' +
                                            getOrderByClass('BuyerName')}
                                              onClick={async () => {
                                                  await toggleOrderBy('BuyerName')
                                              }}></span>
                                    </th>
                                    <th><span>Order Type</span>
                                        <span aria-label="OrderType" aria-pressed="false" className={'sort-container ' +
                                            getOrderByClass('OrderType')
                                        }
                                              onClick={async () => {
                                                  await toggleOrderBy('OrderType')
                                              }}></span>
                                    </th>
                                    <th className='minw120'><span>Order Creation Date</span>
                                        <span aria-label="OrderCreationDate" aria-pressed="false" className={'sort-container ' +
                                            (getOrderByClass('OrderCreationDate'))
                                        }
                                              onClick={async () => {
                                                  await toggleOrderBy('OrderCreationDate')
                                              }}></span>
                                    </th>
                                    <th><span>Carrier</span>
                                        <span aria-label="Carrier" aria-pressed="false" className={'sort-container ' +
                                            getOrderByClass('Carrier')
                                        }
                                              onClick={async () => {
                                                  await toggleOrderBy('Carrier')
                                              }}></span>
                                    </th>

                                </tr>
                                </thead>
                                {order_list.orderList !== undefined &&
                                    Object.entries(order_list.orderList).length > 0 &&
                                    <tbody>
                                    {Object.entries(order_list.orderList).map((v, i) => (
                                        <React.Fragment key={i}>
                                            <tr
                                                className={expand_list != undefined && expand_list.length > 0 && expand_list.includes(v[1].orderNumber) ? 'align-middle' : 'align-middle'}
                                            >
                                                <td>
                                                    <a className="text-blue2 d-flex align-items-center" href={void (0)}
                                                       onClick={() => System.popup('OrderHistoryEmailPopUp', {
                                                           singleOrder: v[1],
                                                           singleProduct: v[1]
                                                       })}>
                                                        <i className="fa fa-envelope font-16" aria-hidden="true"></i>
                                                    </a>
                                                </td>
                                                <td>
                                                    {v[1]?.isReturnReq && v[1]?.shippedQuantity > 0 ? (
                                                            <Tooltip
                                                                position={'right center'}
                                                                opener={() => (
                                                                    <a className="text-blue2 d-flex align-items-center" href={void (0)}
                                                                       onClick={() => System.popup('OrderHistoryReturnRequestPopup', {
                                                                           singleOrder: v[1],
                                                                           singleProduct: v[1],
                                                                           isProductAvailableFromMainAPI: true
                                                                       })}>
                                                                        <img src={returnrequest} />
                                                                    </a>
                                                                )}
                                                                content={() => (
                                                                    <>
                                                                        <div dangerouslySetInnerHTML={{ __html: 'Request Return' }}>
                                                                        </div>
                                                                    </>
                                                                )} />
                                                        )
                                                        : <img className='cursor-default' src={returnrequestinactive} />
                                                    }
                                                </td>
                                                <td>{v[1].purchaseOrderNumber ? v[1].purchaseOrderNumber : ''}
                                                </td>
                                                <td>{v[1].poLineItemNumber ? v[1].poLineItemNumber : ''}</td>
                                                <td>
                                                    {v[1].webOrderNumber ?
                                                        <div className="d-block">Web#: {v[1].webOrderNumber} </div> : ''}

                                                    {v[1].sapOrderNumber ?
                                                        <div className="d-block">Order#:{v[1].sapOrderNumber} </div> : ''}

                                                </td>
                                                <td>{v[1].lineItemNumber}</td>
                                                <td>{v[1].manufacturerName}</td>

                                                <td>
                                                    <div>
                                                        {
                                                            v[1].itemNumber && v[1].manufacturerPartNumber ?
                                                                <NavigateToPDP  data={{
                                                                    ManufacturerName: v[1]?.manufacturerName,
                                                                    ERPMFRPartNumber: v[1]?.manufacturerPartNumber,
                                                                    ItemNumber: v[1]?.itemNumber,
                                                                }} target="_blank" class="text-blue2 font-bold">
                                                                    <span  className="text-blue2 font-bold">  {v[1].manufacturerPartNumber}</span>
                                                                </NavigateToPDP>
                                                                :
                                                                <div>{v[1].manufacturerPartNumber}</div>
                                                        }
                                                    </div>

                                                </td>

                                                <td>{v[1].customerPartNumber}</td>
                                                <td>{v[1].totalQuantity}</td>
                                                <td>{v[1].requestedQuantity}</td>
                                                <td>{v[1].finalRequestedDate}</td>
                                                <td>{v[1].confirmedQuantity}</td>
                                                <td>{v[1].finalConfirmedDate}</td>
                                                <td>{v[1].orderStatus}</td>
                                                <td>{v[1].shippedQuantity}</td>
                                                <td>{v[1].deliveryNumber}</td>
                                                <td>
                                                    {v[1].trackingNumber ?
                                                        v[1].trackingUrl ?
                                                            <div className='sub-section-data text-wrap'>
                                                                <a href={v[1].trackingUrl}
                                                                   target="_blank" className="text-blue2">{v[1].trackingNumber}</a></div>
                                                            :
                                                            <p>{v[1].trackingNumber}</p>
                                                        :
                                                        ''
                                                    }
                                                </td>
                                                <td>{v[1].currency ? v[1].currency : ''}</td>
                                                <td>
                                                    {v[1].price ? Helper.getFormatNumber(v[1].price, v[1].currency) : Helper.getFormatNumber(0, v[1].currency)}
                                                </td>
                                                <td>
                                                    {v[1].priceBasedQuantity && parseInt(v[1].priceBasedQuantity)}
                                                </td>
                                                <td>{v[1].currencyFluctuation}</td>
                                                <td>{v[1].cfCurrency}</td>
                                                <td>
                                                    {v[1].cfAgreedRate && v[1].cfAgreedRate}
                                                </td>
                                                <td>
                                                    {v[1].itemTotalPrice ? Helper.getFormatNumber(v[1].itemTotalPrice, v[1].currency) : Helper.getFormatNumber(0, v[1].currency)}
                                                </td>
                                                <td><span className="text-nowrap">{v[1].invoiceNumber ? <a href={void (0)} aria-label="InvoiceGenerationlink"
                                                                                                           onClick={() => downloadSingleInvoice(v[1].invoiceNumber)}>{v[1].invoiceNumber} </a> : ''}</span></td>
                                                <td>{v[1].webOrderNumber}</td>
                                                <td>{v[1].buyerName}</td>
                                                <td>{v[1].orderType ? v[1].orderType : ''}</td>
                                                <td>{v[1].finalOrderCreationDate}</td>
                                                <td>{v[1].carrier}</td>

                                            </tr>

                                        </ React.Fragment>
                                    ))}
                                    </tbody>
                                }
                            </table>
                        </div>
                    }
                    <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} isOrderModule={true} />
                </div>
            }

            {
                !__check(['ORDER_API_CALL']).status && (order_list === undefined || Object.keys(order_list).length === 0 ||
                    order_list.orderList === undefined ||
                    Object.entries(order_list.orderList).length === 0) && dateRange &&

                <center>
                    <div className='mb-3 text-center'>
                        <div>
                            <strong>Sorry! No Result Found.</strong>
                        </div>
                        We can't find any results based on your selection.
                    </div>
                </center>
            }
        </>
    )
}

export default OrderHistoryListing